import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useSimpleSearchTheme } from '@/shared/ui/search/SimpleSearch/theme/useSimpleSearchTheme';
import type { SimpleSearchField } from '@/shared/ui/search/SimpleSearch/types/search.types';

interface FieldSelectSimpleProps {
  value: string;
  fields: readonly SimpleSearchField[];
  onChange: (fieldName: string) => void;
  label?: string;
}

export function FieldSelectSimple({
  value,
  fields,
  onChange,
  label = '필드',
}: FieldSelectSimpleProps) {
  const { fieldSelectSx } = useSimpleSearchTheme();

  return (
    <FormControl sx={fieldSelectSx} size="small">
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={(e) => onChange(e.target.value)}>
        {fields.map((field) => (
          <MenuItem key={field.name} value={field.name}>
            {field.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
